// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_3m-1";
export var rateTableServiceLevelDropdown = "_3m-3";
export var rateTableTypeDropdown = "_3m-0";
export var rateTableValueModeDropdown = "_3m-2";